// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file role.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { RoleType } from "./role_type_pb";
import { file_role_type } from "./role_type_pb";
import { file_vault_permission_level } from "./vault_permission_level_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file role.proto.
 */
export const file_role: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_role_type, file_vault_permission_level]);

/**
 * @generated from message domain.RolePermissions
 */
export type RolePermissions = Message<"domain.RolePermissions"> & {
  /**
   * permissions (potentially) requiring admin profile access
   *
   * @generated from field: domain.MaximumAssignableVaultPermission admin_can_assign_team_permission_other = 12;
   */
  adminCanAssignTeamPermissionOther: MaximumAssignableVaultPermission;

  /**
   * @generated from field: domain.MaximumAssignableVaultPermission admin_can_assign_team_permission_self = 13;
   */
  adminCanAssignTeamPermissionSelf: MaximumAssignableVaultPermission;

  /**
   * @generated from field: bool admin_can_change_settings = 4;
   */
  adminCanChangeSettings: boolean;

  /**
   * @generated from field: bool admin_can_manage_organization = 1;
   */
  adminCanManageOrganization: boolean;

  /**
   * @generated from field: bool admin_can_view_foreign_personal_vaults = 11;
   */
  adminCanViewForeignPersonalVaults: boolean;

  /**
   * @generated from field: domain.ExportPermission export_vaults = 3;
   */
  exportVaults: ExportPermission;

  /**
   * @generated from field: domain.ChildOrganizationAccess child_organization_access = 9;
   */
  childOrganizationAccess: ChildOrganizationAccess;

  /**
   * permissions without admin profile access
   *
   * @generated from field: bool can_access_personal_vault = 8;
   */
  canAccessPersonalVault: boolean;

  /**
   * @generated from field: bool can_change_plan = 6;
   */
  canChangePlan: boolean;

  /**
   * @generated from field: bool can_connect_users = 14;
   */
  canConnectUsers: boolean;

  /**
   * @generated from field: bool can_create_child_organizations = 10;
   */
  canCreateChildOrganizations: boolean;

  /**
   * @generated from field: bool can_create_teams = 2;
   */
  canCreateTeams: boolean;

  /**
   * @generated from field: bool can_view_auditlog = 5;
   */
  canViewAuditlog: boolean;

  /**
   * @generated from field: bool can_view_monitoring = 7;
   */
  canViewMonitoring: boolean;

  /**
   * @generated from field: bool can_view_users = 15;
   */
  canViewUsers: boolean;
};

/**
 * Describes the message domain.RolePermissions.
 * Use `create(RolePermissionsSchema)` to create a new message.
 */
export const RolePermissionsSchema: GenMessage<RolePermissions> = /*@__PURE__*/
  messageDesc(file_role, 0);

/**
 * @generated from message domain.Role
 */
export type Role = Message<"domain.Role"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.RoleType role_type = 2;
   */
  roleType: RoleType;

  /**
   * @generated from field: string custom_name = 3;
   */
  customName: string;

  /**
   * @generated from field: bool is_privileged = 4;
   */
  isPrivileged: boolean;

  /**
   * @generated from field: domain.RolePermissions permissions = 6;
   */
  permissions?: RolePermissions | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp changed_at = 7;
   */
  changedAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role> = /*@__PURE__*/
  messageDesc(file_role, 1);

/**
 * @generated from enum domain.ExportPermission
 */
export enum ExportPermission {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: EXPORT_PERMISSION_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: EXPORT_PERMISSION_PERSONAL_VAULT = 1;
   */
  PERSONAL_VAULT = 1,

  /**
   * @generated from enum value: EXPORT_PERMISSION_ACCESSIBLE_VAULTS = 2;
   */
  ACCESSIBLE_VAULTS = 2,

  /**
   * @generated from enum value: EXPORT_PERMISSION_ADMIN_ALL_ORGANIZATION_TEAMS = 3;
   */
  ADMIN_ALL_ORGANIZATION_TEAMS = 3,
}

/**
 * Describes the enum domain.ExportPermission.
 */
export const ExportPermissionSchema: GenEnum<ExportPermission> = /*@__PURE__*/
  enumDesc(file_role, 0);

/**
 * @generated from enum domain.ChildOrganizationAccess
 */
export enum ChildOrganizationAccess {
  /**
   * @generated from enum value: CHILD_ORGANIZATION_ACCESS_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: CHILD_ORGANIZATION_ACCESS_LIST = 1;
   */
  LIST = 1,

  /**
   * @generated from enum value: CHILD_ORGANIZATION_ACCESS_ADMIN_MANAGE = 2;
   */
  ADMIN_MANAGE = 2,
}

/**
 * Describes the enum domain.ChildOrganizationAccess.
 */
export const ChildOrganizationAccessSchema: GenEnum<ChildOrganizationAccess> = /*@__PURE__*/
  enumDesc(file_role, 1);

/**
 * @generated from enum domain.MaximumAssignableVaultPermission
 */
export enum MaximumAssignableVaultPermission {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: MAXIMUM_ASSIGNABLE_VAULT_PERMISSION_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: MAXIMUM_ASSIGNABLE_VAULT_PERMISSION_READ_ONLY = 1;
   */
  READ_ONLY = 1,

  /**
   * @generated from enum value: MAXIMUM_ASSIGNABLE_VAULT_PERMISSION_READ_WRITE = 2;
   */
  READ_WRITE = 2,

  /**
   * @generated from enum value: MAXIMUM_ASSIGNABLE_VAULT_PERMISSION_ADMIN = 3;
   */
  ADMIN = 3,
}

/**
 * Describes the enum domain.MaximumAssignableVaultPermission.
 */
export const MaximumAssignableVaultPermissionSchema: GenEnum<MaximumAssignableVaultPermission> = /*@__PURE__*/
  enumDesc(file_role, 2);

